import ihr from './components/common/separatorLine';
import iPage from './components/common/pageVO';
import ih7 from './components/common/ih7';
import user from './components/common/user';
import ihlpUpload from './components/common/file/ihlpUpload';
import dropdown from './components/common/dropdown';
import region from './components/common/region';
import ihlpTree from './components/common/tree/tree';
import iTable from './components/common/table/table';
import iButton from './components/common/btn/button';
import DatePicker from './components/common/datePicker'
import ihlpCarousel from './components/common/carousel/carousel'
import ihlpCarouselBanner from './components/common/carousel/carouselBanner'
import Icon from './components/common/icon';
import iQrcode from './components/common/qrcode';
import number from './components/common/inumber';
import inputPhone from './components/common/inputPhone';
import nationalDrop from './components/common/nationalDrop';
import Input from './components/common/input';
import Tabs from './components/common/tabs';
const components = {
    ihr,
    page:iPage,
    ih7,
    user,
    ihlpUpload,
    dropdown,
    region,
    ihlpTree,
    Table:iTable,
    Button:iButton,
    iButton:iButton,
    DatePicker,
    ihlpCarousel,
    carouselBanner:ihlpCarouselBanner,
    Icon,
    iQrcode,
    inumber:number,
    inputPhone,
    nationalDrop,
    Input,
    Tabs: Tabs,
    TabPane: Tabs.Pane,
};

const ihlp = {
    ...components
};

const install = function(Vue, opts = {}) {
    if (install.installed) return;
    Object.keys(ihlp).forEach(key => {
        Vue.component(key, ihlp[key]);
    });

    Vue.prototype.$IHLP = {
        size: opts.size || '',
        transfer: 'transfer' in opts ? opts.transfer : ''
    };
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

const API = {
    install,
    ...components
};

export default API;



// WEBPACK FOOTER //
// ./src/ihlp.js